<template>
  <div class="lk-mobile-notify">
    <div class="lk-mobile-notify__content" :class="{ 'lk-mobile-notify__content--fade': isBottomFadeVisible }">
      <div class="lk-mobile-notify__head">
        <div class="lk-mobile-notify__title">
          {{ notificationsCountLabel }}
          {{ $root.staticText.lk.notify }}
        </div>

        <router-link :to="{ name: 'lk-notifications' }" class="t-main-head__all t-lk-link lk-mobile-notify__all-link">
          <span>{{ $root.staticText.lk.notifyAll }}</span>
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.8396 3.93238C5.60815 4.16383 5.60815 4.53908 5.8396 4.77053L9.56918 8.50011L5.8396 12.2297C5.60815 12.4611 5.60815 12.8364 5.8396 13.0678C6.07105 13.2993 6.44631 13.2993 6.67776 13.0678L10.8264 8.91918C11.0579 8.68774 11.0579 8.31248 10.8264 8.08103L6.67776 3.93238C6.44631 3.70093 6.07105 3.70093 5.8396 3.93238Z"
              fill="#00b0bd"
            />
          </svg>
        </router-link>
      </div>

      <div ref="scrollContainer" class="lk-mobile-notify__list">
        <div v-for="item in notifications" :key="getNotificationKey(item)" class="lk-mobile-notify__item">
          <div class="lk-mobile-notify__row">
            <div class="lk-mobile-notify__tag">
              {{ item.tag }}
            </div>
          </div>

          <div class="lk-mobile-notify__name">
            {{ item.name }}
          </div>

          <div class="lk-mobile-notify__date">
            {{ item.date }}
            <svg
              class="lk-mobile-notify__date-icon"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.00013 2.53322C6.55028 2.53322 5.15981 3.10917 4.13461 4.13437C3.10941 5.15957 2.53346 6.55004 2.53346 7.99989C2.53346 8.71778 2.67486 9.42864 2.94959 10.0919C3.22431 10.7551 3.62699 11.3578 4.13461 11.8654C4.64224 12.373 5.24488 12.7757 5.90813 13.0504C6.57137 13.3252 7.28224 13.4666 8.00013 13.4666C8.71802 13.4666 9.42889 13.3252 10.0921 13.0504C10.7554 12.7757 11.358 12.373 11.8656 11.8654C12.3733 11.3578 12.7759 10.7551 13.0507 10.0919C13.3254 9.42864 13.4668 8.71778 13.4668 7.99989C13.4668 6.55004 12.8908 5.15957 11.8656 4.13437C10.8404 3.10917 9.44998 2.53322 8.00013 2.53322ZM3.38037 3.38012C4.6056 2.15488 6.26738 1.46655 8.00013 1.46655C9.73288 1.46655 11.3947 2.15488 12.6199 3.38012C13.8451 4.60536 14.5335 6.26714 14.5335 7.99989C14.5335 8.85786 14.3645 9.70742 14.0361 10.5001C13.7078 11.2927 13.2266 12.013 12.6199 12.6196C12.0132 13.2263 11.293 13.7076 10.5003 14.0359C9.70767 14.3642 8.8581 14.5332 8.00013 14.5332C7.14216 14.5332 6.29259 14.3642 5.49993 14.0359C4.70727 13.7076 3.98704 13.2263 3.38037 12.6196C2.77369 12.013 2.29245 11.2927 1.96412 10.5001C1.63579 9.70742 1.4668 8.85786 1.4668 7.99989C1.4668 6.26714 2.15513 4.60536 3.38037 3.38012ZM8.00013 4.79989C8.29468 4.79989 8.53346 5.03867 8.53346 5.33322V7.77897L10.3773 9.62276C10.5855 9.83104 10.5855 10.1687 10.3773 10.377C10.169 10.5853 9.83129 10.5853 9.62301 10.377L7.62301 8.37701C7.52299 8.27699 7.4668 8.14134 7.4668 7.99989V5.33322C7.4668 5.03867 7.70558 4.79989 8.00013 4.79989Z"
                fill="#C0C0CC"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LkMobileNotify',
  data() {
    return {
      isBottomFadeVisible: true,
      scrollContainerEl: null,
    }
  },
  computed: {
    ...mapGetters('lk', ['profile']),

    notifications() {
      return this.profile?.notifications ?? []
    },
    notificationsCountLabel() {
      return this.notifications.length > 99 ? '99+' : String(this.notifications.length)
    },
  },
  mounted() {
    this.bindScroll()
  },
  updated() {
    this.bindScroll()
    this.updateBottomFadeVisibility()
  },
  beforeDestroy() {
    this.unbindScroll()
  },
  methods: {
    bindScroll() {
      const el = this.$refs.scrollContainer

      if (!el || this.scrollContainerEl === el) return

      this.unbindScroll()
      this.scrollContainerEl = el
      this.scrollContainerEl.addEventListener('scroll', this.updateBottomFadeVisibility)
      this.updateBottomFadeVisibility()
    },
    unbindScroll() {
      if (!this.scrollContainerEl) return

      this.scrollContainerEl.removeEventListener('scroll', this.updateBottomFadeVisibility)
      this.scrollContainerEl = null
    },
    updateBottomFadeVisibility() {
      const el = this.$refs.scrollContainer
      if (!el) return

      const maxScrollTop = el.scrollHeight - el.clientHeight
      this.isBottomFadeVisible = el.scrollTop < maxScrollTop
    },
    getNotificationKey(item) {
      return `${item?.tag || ''}-${item?.date || ''}-${item?.name || ''}`
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.lk-mobile-notify
  &__content
    position: relative

    &::after
      content: ''
      position: absolute
      left: 0
      bottom: 0
      width: 100%
      height: 92px
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)
      pointer-events: none
      opacity: 0
      transition: opacity .3s

    &--fade::after
      opacity: 1

  &__head
    display: flex
    flex-direction: column
    align-items: flex-start
    padding: 0 0 16px
    border-bottom: 1px solid #F5F5FA

    @media (min-width: $desktop-medium)
      padding: 0 0 24px

  &__title
    margin-bottom: 8px
    color: #1E253B
    font-family: 'Proxima Nova Semi', sans-serif
    font-size: 18px
    line-height: 130%

  &__all-link
    width: fit-content

  &__list
    max-height: 320px
    margin: 16px 0 0
    padding: 0 8px 0 0
    overflow-x: hidden
    overflow-y: auto

    @media (min-width: $desktop-medium)
      max-height: 340px
      margin-top: 24px

  &__item
    padding: 16px
    background: #F5F5FA
    border-radius: 6px

    &:not(:last-child)
      margin-bottom: 8px

  &__row
    display: flex
    align-items: center
    justify-content: space-between
    margin-bottom: 8px

  &__tag
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
    color: #C0C0CC
    font-size: 12px
    line-height: 130%

  &__name
    color: #293045
    font-family: 'Segoe UI', sans-serif
    font-size: 14px
    font-weight: 600
    line-height: 130%

    @media (min-width: $desktop-medium)
      font-size: 16px

  &__date
    display: flex
    align-items: center
    margin-top: 12px
    color: #C0C0CC
    font-size: 12px
    line-height: 130%
    white-space: nowrap

  &__tag, &__date
    @media (min-width: $desktop-medium)
      font-size: 14px

  &__date-icon
    display: block
    margin-left: 8px
</style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/lk-mobile-notify.vue